export default "__VITE_ASSET__DnRagbVM__"